import { useState, useCallback } from 'react';
import type { SimpleSearchQuery } from '@/shared/ui/search/SimpleSearch/types/search.types';

export function useSimpleSearch(initialQuery?: SimpleSearchQuery) {
  const [query, setQuery] = useState<SimpleSearchQuery>(
    initialQuery || {
      fieldName: undefined,
      value: '',
    }
  );

  const setFieldName = useCallback((fieldName: string) => {
    setQuery((prev) => ({ ...prev, fieldName }));
  }, []);

  const setValue = useCallback((value: string) => {
    setQuery((prev) => ({ ...prev, value }));
  }, []);

  const resetQuery = useCallback(() => {
    setQuery({
      fieldName: undefined,
      value: '',
    });
  }, []);

  return {
    query,
    setQuery,
    setFieldName,
    setValue,
    resetQuery,
  };
}
